export default __webpack_public_path__ + "static/media/positive.92aa2586.png";